var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Widget',{attrs:{"width":"335","height":"335"}},[_c('Clock')],1)}
var staticRenderFns = []

export { render, staticRenderFns }